import { render, staticRenderFns } from "./docuAbout.vue?vue&type=template&id=0e75284b&scoped=true&"
import script from "./docuAbout.vue?vue&type=script&lang=js&"
export * from "./docuAbout.vue?vue&type=script&lang=js&"
import style0 from "./docuAbout.vue?vue&type=style&index=0&id=0e75284b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75284b",
  null
  
)

export default component.exports